import CategoryWidget from './CategoryWidget';

export default CategoryWidget;
